import { EffectsModule } from '@ngrx/effects';
import {
  ROUTER_REQUEST,
  RouterRequestAction,
  StoreRouterConnectingModule,
  routerReducer,
} from '@ngrx/router-store';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { NgModule } from '@angular/core';

import { localStorageSync } from 'ngrx-store-localstorage';

import { environment } from 'environments/environment';
import { OIDC_STORAGE_KEY } from '@core/auth';
import { logOut } from '@core/auth/@store/user/user.actions';
import { userFeatureKey } from '@core/auth/@store/user/user.reducer';

export function localStorageSyncReducer(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return localStorageSync({
    keys: [OIDC_STORAGE_KEY, userFeatureKey, ...environment.syncLocalStorage],
    rehydrate: true,
  })(reducer);
}

export function resetState(
  reducer: (state: any, action: any) => any
): (state: any, action: any) => any {
  return (state, action): any => {
    let isLoginPreloader = false;
    let isLogout = false;
    if (action.type === ROUTER_REQUEST) {
      const navigationAction = action as RouterRequestAction;
      isLoginPreloader =
        navigationAction.payload.event.url.indexOf('/login-preloader') === 0;
    }

    if (action.type === logOut.type) {
      isLogout = true;
    }

    if (isLoginPreloader || isLogout) {
      state = undefined;
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer[] = [
  resetState,
  localStorageSyncReducer,
];

const devModules = environment.production
  ? []
  : [
      StoreDevtoolsModule.instrument({
        maxAge: 10,
      }),
    ];

@NgModule({
  imports: [
    StoreModule.forRoot(
      {
        router: routerReducer,
      },
      {
        metaReducers,
        runtimeChecks: {
          strictStateImmutability: false, // TODO: https://github.com/ngrx/platform/issues/2109
          strictActionImmutability: false, // TODO: https://github.com/ngrx/platform/issues/2109
        },
      }
    ),
    EffectsModule.forRoot([]),
    // Connects RouterModule with StoreModule
    StoreRouterConnectingModule.forRoot(),
    ...devModules,
  ],
  providers: [],
})
export class MwCoreStoreModule {}
